import styled from 'styled-components/native'

export const RootContainer = styled.ScrollView`
  flex: 1;
`
export const AcitivityViewContainer = styled.View`
  flex: 1;
  justify-content: center;
`
